/**
 * Vergi Kimlik Numarasi (VKN) dogrulamasi.
 *
 * Tuzel kisiye fatura kesilirken VKN yanlis girilirse fatura GIB'den geri
 * doner ve hata cikisti yapan misafirin karsisinda ogrenilir. Sadece "10
 * hane" kontrolu yetmez; resmi kontrol hanesi algoritmasi burada uygulanir.
 *
 * Algoritma (Gelir Idaresi): ilk 9 hane sirasiyla donusturulur, elde edilen
 * toplamin birler basamagi 10'a tamamlanarak 10. hane (kontrol hanesi) bulunur.
 */
export function vknGecerliMi(deger: string | null | undefined): boolean {
  if (!deger) return false;
  const vkn = deger.trim();
  if (!/^\d{10}$/.test(vkn)) return false;

  const h = [...vkn].map(Number);
  let toplam = 0;
  for (let i = 0; i < 9; i++) {
    const gecici = (h[i]! + (9 - i)) % 10;
    // 9 cikarsa oldugu gibi eklenir; aksi halde 2'nin kuvvetiyle carpilip mod 9 alinir.
    toplam += gecici === 9 ? gecici : (gecici * 2 ** (9 - i)) % 9;
  }
  const kontrol = toplam % 10 === 0 ? 0 : 10 - (toplam % 10);
  return kontrol === h[9];
}

/** Ekranda gosterim: 1234567890 -> 1234567890 (VKN gizli veri degildir). */
export function vknBicimle(deger: string): string {
  return deger.trim().replace(/\D/g, '').slice(0, 10);
}
